// extracted by mini-css-extract-plugin
export default {"popup":"ModalOverlay_popup__lR+De","flareAnimation":"ModalOverlay_flareAnimation__PxZUW","shine":"ModalOverlay_shine__MHWO2"};